import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成 条件搜索时候 请把条件安好后台定制的结构体字段 放到 this.searchInfo 中即可实现条件搜索

import { getApiById, getApiList, createApi, updateApi, deleteApi as _deleteApi, deleteApisByIds } from '@/api/api';
import infoList from '@/mixins/infoList';
import { toSQLLine } from '@/utils/stringFun';
var methodOptions = [{
  value: 'POST',
  label: '创建',
  type: 'success'
}, {
  value: 'GET',
  label: '查看',
  type: ''
}, {
  value: 'PUT',
  label: '更新',
  type: 'warning'
}, {
  value: 'DELETE',
  label: '删除',
  type: 'danger'
}];
export default {
  name: 'Api',
  filters: {
    methodFiletr: function methodFiletr(value) {
      var target = methodOptions.filter(function (item) {
        return item.value === value;
      })[0];
      // return target && `${target.label}(${target.value})`
      return target && "".concat(target.label);
    },
    tagTypeFiletr: function tagTypeFiletr(value) {
      var target = methodOptions.filter(function (item) {
        return item.value === value;
      })[0];
      return target && "".concat(target.type);
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      deleteVisible: false,
      listApi: getApiList,
      dialogFormVisible: false,
      dialogTitle: '新增Api',
      apis: [],
      form: {
        path: '',
        apiGroup: '',
        method: '',
        description: ''
      },
      methodOptions: methodOptions,
      type: '',
      rules: {
        path: [{
          required: true,
          message: '请输入api路径',
          trigger: 'blur'
        }],
        apiGroup: [{
          required: true,
          message: '请输入组名称',
          trigger: 'blur'
        }],
        method: [{
          required: true,
          message: '请选择请求方式',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入api介绍',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    //  选中api
    handleSelectionChange: function handleSelectionChange(val) {
      this.apis = val;
    },
    onDelete: function onDelete() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ids, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = _this.apis.map(function (item) {
                return item.ID;
              });
              _context.next = 1;
              return deleteApisByIds({
                ids: ids
              });
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                _this.$message({
                  type: 'success',
                  message: res.msg
                });
                if (_this.tableData.length === ids.length && _this.page > 1) {
                  _this.page--;
                }
                _this.deleteVisible = false;
                _this.getTableData();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 排序
    sortChange: function sortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (prop) {
        this.searchInfo.orderKey = toSQLLine(prop);
        this.searchInfo.desc = order === 'descending';
      }
      this.getTableData();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    initForm: function initForm() {
      this.$refs.apiForm.resetFields();
      this.form = {
        path: '',
        apiGroup: '',
        method: '',
        description: ''
      };
    },
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
    },
    openDialog: function openDialog(type) {
      switch (type) {
        case 'addApi':
          this.dialogTitle = '新增Api';
          break;
        case 'edit':
          this.dialogTitle = '编辑Api';
          break;
        default:
          break;
      }
      this.type = type;
      this.dialogFormVisible = true;
    },
    editApi: function editApi(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getApiById({
                id: row.ID
              });
            case 1:
              res = _context2.sent;
              _this2.form = res.data.api;
              _this2.openDialog('edit');
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    deleteApi: function deleteApi(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.$confirm('此操作将永久删除所有角色下该api, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var res;
                return regeneratorRuntime.wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 1;
                      return _deleteApi(row);
                    case 1:
                      res = _context3.sent;
                      if (res.code === 0) {
                        _this3.$message({
                          type: 'success',
                          message: '删除成功!'
                        });
                        if (_this3.tableData.length === 1 && _this3.page > 1) {
                          _this3.page--;
                        }
                        _this3.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }))).catch(function () {
                _this3.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this4.$refs.apiForm.validate(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
                  var res, _res, _t;
                  return regeneratorRuntime.wrap(function (_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!valid) {
                          _context5.next = 6;
                          break;
                        }
                        _t = _this4.type;
                        _context5.next = _t === 'addApi' ? 1 : _t === 'edit' ? 3 : 5;
                        break;
                      case 1:
                        _context5.next = 2;
                        return createApi(_this4.form);
                      case 2:
                        res = _context5.sent;
                        if (res.code === 0) {
                          _this4.$message({
                            type: 'success',
                            message: '添加成功',
                            showClose: true
                          });
                        }
                        _this4.getTableData();
                        _this4.closeDialog();
                        return _context5.abrupt("continue", 6);
                      case 3:
                        _context5.next = 4;
                        return updateApi(_this4.form);
                      case 4:
                        _res = _context5.sent;
                        if (_res.code === 0) {
                          _this4.$message({
                            type: 'success',
                            message: '编辑成功',
                            showClose: true
                          });
                        }
                        _this4.getTableData();
                        _this4.closeDialog();
                        return _context5.abrupt("continue", 6);
                      case 5:
                        _this4.$message({
                          type: 'error',
                          message: '未知操作',
                          showClose: true
                        });
                        return _context5.abrupt("continue", 6);
                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};